import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/recurring-invoices/new/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/invoices/recurring-invoices/new', replace: true })
  },
})
